import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, CircularProgress } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext, {getPointsByQuizz} from "../../../contexts/UserContext"
import SuperAdminContext from "../../../contexts/SuperAdminContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"
import DiagHelper from "../../ui/Admin/Formations/FormatHelpers/DiagHelper"

import './FormatDiag.css'

const FormatDiag = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }


  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)
  const [results, setResults] = useState(null)
  useEffect(() => {
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice) {
        setResults(format?.userChoice)
      } else {
        setResults(null)
      }
    } else {
      if (!onlyContent) {
        getUserResult()
      }
      setIsAlreadyAnswer(false)
    }
  }, [format, onlyContent])

  const getUserResult = () => {
    //console.log("getUserResult")
    let categories = {master: { points: 0, max: 0, score: 0 }}
    if (format?.isChapter === true && actFormation) {
      categories.glbMaster = { points: 0, max: 0, score: 0 }
    }

    let glbMasterPond = []
    if (actFormation?.glbMasterPond !== null) {
      glbMasterPond = JSON.parse(actFormation?.glbMasterPond)
    }

    const manageFormat = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        const [points, max] = getPointsByQuizz(format)
        //const makeResult = (o) => ({ ...o, max: o.max + max, points: o.points + points, score: o.max > 0 ? Math.round((o.points / o.max) * 100) : 100 })
        const makeResult = (c, points, max) => {
          let newPoints = c.points+points
          let newMax = c.max+max
          return {
            points : newPoints,
            max : newMax,
            score : Math.round((newPoints / newMax) * 100)
          }
        }
        categories.master = makeResult(categories.master, points, max)
        if (format.categorie && format.categorie !== 'master') {
          categories[format.categorie] = makeResult(categories[format.categorie] ?? { points: 0, max: 0, score: 0  }, points, max)
        }
      }
    }

    const manageFormatGlb = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        const [points, max] = getPointsByQuizz(format)
        //const makeResult = (o) => ({ ...o, max: o.max + max, points: o.points + points, score: o.max > 0 ? Math.round((o.points / o.max) * 100) : 100 })
        const makeResult = (c, points, max) => {
          //on cherche si la categorie est à ignorer ou non
          let statut = "oui"
          let find = glbMasterPond.find((el) => el.key === format.categorie)
          if (find) {
            statut = find.value
          }
          if (statut === "oui") {
            let newPoints = c.points+points
            let newMax = c.max+max
            return {
              points : newPoints,
              max : newMax,
              score : Math.round((newPoints / newMax) * 100)
            }
          } else {
            return {
              points : c.points,
              max : c.max,
              score : Math.round((c.points / c.max) * 100),
            }
          }
        }
        categories.glbMaster = makeResult(categories.glbMaster, points, max)
      }
    }

    //formation
    if (format?.isChapter === true) {
      //master glb
      if (actFormation) {
        for (var c in actFormation?.chapitre) {
          for (var i in actFormation?.chapitre[c]?.partie) {
            for (var n in actFormation?.chapitre[c]?.partie[i]?.sequence) {
              manageFormatGlb(actFormation?.chapitre[c]?.partie[i]?.sequence[n])
            }
          }
        }
      }
      //master + autres catégories
      const parts = actFormation?.chapitre[actIndex?.chapitre]?.partie
      for (var i in parts) {
        for (var n in parts[i].sequence) {
          manageFormat(parts[i].sequence[n])
        }
      }
    } else {
      let actPart = actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]
      for (var i = actIndex?.sequence - 1; i >= 0; i--) {
        manageFormat(actPart?.sequence[i])
      }
    }

    setResults(categories)
  }

  const [catsToDisplay, setCatsToDisplay] = useState([])
  const [activeButton, setActiveButton] = useState(false)

  useEffect(() => {
    if (results && format) {
      //pour categories
      let categorieByScore = JSON.parse(JSON.stringify(format?.categorie))
      categorieByScore.map((cat, i) => {
        let userResult = results[cat.key] ? results[cat.key] : {score: 0, points: 0, max : 0}
        cat.score = userResult?.score
      })

      //on sort les catégories master et glbMaster du trie
      let masterCats = []
      let findMaster = categorieByScore.find((el) => el.key === "master")
      if (findMaster) {
        masterCats.push(findMaster)
      }
      let findGlbMaster = categorieByScore.find((el) => el.key === "glbMaster")
      if (findGlbMaster) {
        masterCats.push(findGlbMaster)
      }

      //on supprimer les catégories master et glbMaster du premier tableau
      categorieByScore = categorieByScore.filter((el) => el.key !== "master")
      categorieByScore = categorieByScore.filter((el) => el.key !== "glbMaster")

      if (isEditor !== true) {
        categorieByScore.sort((a,b) => b.score - a.score);
      } else {
        //console.log("on est sur l'éditeur -> pas de besoin de trier par score")
      }

      categorieByScore = masterCats.concat(categorieByScore)
      setCatsToDisplay(categorieByScore)


      if (isEditor !== true) {
        let timeForButton = 2500 * categorieByScore?.length
        setTimeout(() => {
          setActiveButton(true)
        }, timeForButton);
      }



    } else {
      setCatsToDisplay([])
    }
  }, [results, format, isEditor])

  const getTitleText = () => {
    if (results && format) {
      let masterScore = 0
      if (isEditor) {
        //editor
        masterScore = results?.fakeMasterForTitle?.score ? results?.fakeMasterForTitle?.score : 0
      } else {
        //pas editor
        masterScore = results?.master?.score ? results?.master?.score : 0
      }
      for (let i=0; i<format?.total?.length; i++) {
        let seuil = format?.total[i]
        if (masterScore >= seuil?.seuil) {
          return seuil?.text
          break;
        }
      }
    }

    return ""
  }

  /* EDITOR ADMIN */
  useEffect(() => {
    if (isEditor) {
      //on doit déjà refaire la liste des catégories dispos
      let categories = {master: { max: 0 }}
      if (format?.isChapter === true) {
        categories.glbMaster = { max : 0}
      }

      let glbMasterPond = []
      if (actFormation?.glbMasterPond !== null) {
        glbMasterPond = JSON.parse(actFormation?.glbMasterPond)
      }

      const manageFormat = (format) => {
        if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
          const [points, max] = getPointsByQuizz(format)
          const makeResult = (c, max) => {
            let newMax = c.max+max
            return { max : newMax }
          }
          categories.master = makeResult(categories.master, max)
          if (format.categorie && format.categorie !== 'master') {
            categories[format.categorie] = makeResult(categories[format.categorie] ?? { max: 0, score: 0  }, max)
          }
        }
      }

      const manageFormatGlb = (format) => {
        if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
          const [points, max] = getPointsByQuizz(format)
          const makeResult = (c, max) => {
            //on cherche si la categorie est à ignorer ou non
            let statut = "oui"
            let find = glbMasterPond.find((el) => el.key === format.categorie)
            if (find) {
              statut = find.value
            }
            if (statut === "oui") {
              let newMax = c.max+max
              return { max : newMax }
            } else {
              return { max : c.max }
            }
          }
          categories.glbMaster = makeResult(categories.glbMaster, max)
        }
      }

      if (format?.isChapter === true) {
        //master glb
        if (actFormation) {
          for (var c in actFormation?.chapitre) {
            for (var i in actFormation?.chapitre[c]?.partie) {
              for (var n in actFormation?.chapitre[c]?.partie[i]?.sequence) {
                manageFormatGlb(actFormation?.chapitre[c]?.partie[i]?.sequence[n])
              }
            }
          }
        }
        //master + autres catégories
        const parts = actFormation?.chapitre[actIndex?.chapitre]?.partie
        for (var i in parts) {
          for (var n in parts[i].sequence) {
            manageFormat(parts[i].sequence[n])
          }
        }
      } else {
        let actPart = actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]
        for (var i = actIndex?.sequence - 1; i >= 0; i--) {
          manageFormat(actPart?.sequence[i])
        }
      }

      //on regarde si on a des catégories qui sont dans le format mais en fait pas dispo
      let saveForAutoDelete = false;
      let categoriesForDelete = JSON.parse(JSON.stringify(format?.categorie))
      categoriesForDelete = categoriesForDelete?.filter((el) => {
        if (!categories[el.key]) {
          saveForAutoDelete = true
          return false
        } else {
          return true
        }
      })

      let categorieByScore = []

      if (saveForAutoDelete === true) {
        categorieByScore = JSON.parse(JSON.stringify(categoriesForDelete))
        superAdminContext?.onSequenceChange(
          'categorie',
          categoriesForDelete,
          superAdminContext?.adminPlayerIndexes
        )
      } else {
        categorieByScore = JSON.parse(JSON.stringify(format?.categorie))
      }

      //ensuite on crée de faux résultats
      let fakeResults = {}
      categorieByScore.map((cat, i) => {
        let findInActResults = results ? results[cat?.key] : null
        if (findInActResults) {
          fakeResults[cat.key] = findInActResults
        } else {
          fakeResults[cat.key] = {score : 0}
        }
      })

      //pour title en haut en editeur
      fakeResults.fakeMasterForTitle = {score : 0}


      setResults(fakeResults)
    }
  }, [format, isEditor])

  const [stepIndex, setStepIndex] = useState(0)
  const [categoriesIndexes, setCategoriesIndexes] = useState({})
  useEffect(() => {
    if (isEditor) {
      if (results) {
        //step Index
        var iSeuil = 0;
        var maxSeuil = 0;
        let thisScore = results["fakeMasterForTitle"]?.score
        let thisSeuils = format?.total
        for (var i =0; i < thisSeuils?.length; i++ ) {
          const step = thisSeuils[i]
          if (thisScore >= step.seuil && step.seuil >= maxSeuil) {
            maxSeuil = step.seuil
            iSeuil = i
          }
        }
        setStepIndex(iSeuil)

        //categoriesIndexes
        const categoriesIndex={}
        for (var cat of format?.categorie) {
          var iSeuil = 0;
          var maxSeuil = 0;
          let thisScore = results[cat?.key]?.score
          let thisSeuils = cat?.seuils
          for (var i =0; i < thisSeuils?.length; i++ ) {
            const step = thisSeuils[i]
            if (thisScore >= step.seuil && step.seuil >= maxSeuil) {
              maxSeuil = step.seuil
              iSeuil = i
            }
          }
          categoriesIndex[cat?.key] = iSeuil
        }
        setCategoriesIndexes(categoriesIndex)

      }
    }
  }, [results, format, isEditor])
  /* END EDITOR ADMIN */

  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <DiagHelper
            format={format}
            results={results}
            setResults={setResults}
            stepIndex={stepIndex}
            categoriesIndexes={categoriesIndexes}
            actFormation={actFormation}
            actIndex={actIndex}
          />
        </EditorPopover>
      }
      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <Box sx={{
          width:"100%",
          maxHeight:["unset", "unset", "unset", "calc(100vh - 260px)"],
          display:isEditor? "flex" : results?"flex":"none",
          flexDirection:["column", "column", "column", "row"],
          gap:["20px", "40px", "40px", "60px"],
          overflow:["unset", "unset", "unset", "hidden"],
        }}>
          <Box sx={{
            flex:["unset", "unset", "unset", 1],
            overflowX:"hidden",
            overflowY:["hidden", "hidden", "hidden", "auto"],
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              margin:'auto 0',
            }}>
              <EditableField
                field={getTitleText()}
                isEditor={isEditor}
                sx={{
                  color:"text.black",
                  fontSize:["26px", "42px", "42px", "46px"],
                  textAlign:"center",
                }}
                type={["total", stepIndex, "text"]}
              />
              <Box sx={{
                marginTop:["20px", "30px", "30px", "50px"],
                display:"flex",
                flexDirection:"column",
                gap:["25px", "30px", "30px", "30px"],
                userSelect:"none",
                alignItems:"center",
                position:"relative",
              }}>
                <Box sx={{
                  position:"fixed",
                  minWidth:["120px", "150px"],
                  minHeight:["120px", "150px"],
                  animation : !onlyContent&&`1.5s linear 2s fadeOut`,
                  animationFillMode: "both !important",
                  opacity : onlyContent?0:1,
                  marginTop:"10px",
                }}>
                  <CircularProgress style={{color:"black", width:"100%", height:"100%"}}/>
                </Box>
                {catsToDisplay.map((cat, i) => {
                  let subTitle = ""
                  let iSeuil = 0
                  for (let i=0; i<cat?.seuils?.length; i++) {
                    let seuil = cat?.seuils[i]
                    if (cat?.score >= seuil?.seuil) {
                      subTitle = seuil?.text || ""
                      iSeuil = i
                      break;
                    }
                  }

                  let dureeAnim = 2 //secondes
                  let delayAnim = (i+1)*2.5 //delay anim en secondes
                  let totalAnim = delayAnim;
                  return (
                    <Box key={i} sx={{
                      width:"100%",
                      animation : !onlyContent&&`${dureeAnim}s linear ${delayAnim}s fadeIn`,
                      animationFillMode: "both !important",
                      opacity : onlyContent?1:0,
                    }}>
                      <Box sx={{
                        display:"flex",
                        gap:["10px", "15px", "15px", "15px"],
                        alignItems:"center",
                      }}>
                        <Box sx={{
                          background:"white",
                          //border:"3px solid #E26438",
                          width:["63px", "77px", "77px", "77px"],
                          minWidth:["63px", "77px", "77px", "77px"],
                          height:["43px", "50px", "50px", "50px"],
                          minHeight:["43px", "50px", "50px", "50px"],
                          color:"text.black",
                          fontSize:["20px", "26px", "26px", "26px"],
                          display:"flex",
                          alignItems:"center",
                          justifyContent:"center",
                          position:"relative",
                          overflow:"hidden",
                        }}>
                          <Box sx={{
                            animation: !onlyContent&&`1s linear ${delayAnim+0}s borderLeft`,
                            animationFillMode: "both !important",
                            position:"absolute",
                            background:"#E26438",
                            left:"0px",
                            top:onlyContent?"0":"-100%",
                            height:"100%",
                            width:"3px",
                          }}/>
                          <Box sx={{
                            animation: !onlyContent&&`1s linear ${delayAnim+1}s borderBottom`,
                            animationFillMode: "both !important",
                            position:"absolute",
                            background:"#E26438",
                            left:onlyContent?"0":"-100%",
                            bottom:"0px",
                            height:"3px",
                            width:"100%",
                          }}/>
                          <Box sx={{
                            animation: !onlyContent&&`1s linear ${delayAnim+2}s borderRight`,
                            animationFillMode: "both !important",
                            position:"absolute",
                            background:"#E26438",
                            right:"0",
                            bottom:onlyContent?"0":"-100%",
                            height:"100%",
                            width:"3px",
                          }}/>
                          <Box sx={{
                            animation: !onlyContent&&`1s linear ${delayAnim+3}s borderTop`,
                            animationFillMode: "both !important",
                            position:"absolute",
                            background:"#E26438",
                            right:onlyContent?"0":"-100%",
                            top:"0px",
                            height:"3px",
                            width:"100%",
                            transform:"rotate(180deg)",
                            transformOrigin:"center",
                          }}/>
                          {cat?.score}%
                        </Box>
                        <Box sx={{
                          whiteSpace:"noWrap",
                          textOverflow:"ellipsis",
                          overflow:"hidden",
                        }}>
                          <EditableField
                            field={cat?.title ? cat.title : cat?.key}
                            isEditor={false}
                            sx={{
                              color:"text.black",
                              fontSize:["18px", "22px", "22px", "22px"],
                              whiteSpace:"noWrap",
                              textOverflow:"ellipsis",
                              overflow:"hidden",
                              //textTransform:"capitalize",
                              "&::first-letter" : {
                                textTransform: "uppercase"
                              }
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{
                        marginTop:"10px",
                      }}>
                        <EditableField
                          field={subTitle}
                          isEditor={isEditor}
                          sx={{
                            color:"text.subTitle",
                            fontSize:["14px", "18px", "18px", "18px"],
                          }}
                          type={["categorie", cat?.key, "seuils", iSeuil, "text"]}
                        />
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            </Box>
          </Box>
        </Box>
        {(onlyContent && results === null && isEditor !== true) &&
          <Box sx={{
            minWidth:["150px", "200px"],
            minHeight:["150px", "200px"],
            marginTop:"50px"
          }}>
            <CircularProgress style={{color:"black", width:"100%", height:"100%"}}/>
          </Box>
        }
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={isEditor}
            disabled={results === null ? true : !activeButton}
            type="button"
            field={format?.button?.text}
            sx={{}}
            onClick={() => {
              manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: results }])
              manageSlide(1)
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatDiag
